import {GenerateDocumentContentMessage} from 'notebook/ai-tools/NotebookAIToolsConstants';
import * as Net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

interface GenerateDocumentContentResponse {
  message: GenerateDocumentContentMessage;
}

interface GenerateDocumentContentResponse {
  message: GenerateDocumentContentMessage;
}

export function generateDocumentContent(
  entryId: string,
  fileS3Locations: Array<string>,
  userPrompt: string,
  notePartIndex: number
): Promise<GenerateDocumentContentResponse> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/notebook/ai-tools:generate-document-content',
    data: {entryId, fileS3Locations, userPrompt, notePartIndex},
  });
}

export interface CheckEntryUsingAIResponse {
  traceId: string;
  checkResults: Array<{text: string}>;
  hadError: boolean;
}

export function checkEntryUsingAI(entryId: string): Promise<CheckEntryUsingAIResponse> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/notebook/ai-tools:check-entry',
    data: {entryId},
  });
}

export interface FillStructuredTableUsingAIRunResultResponse {
  displayName: string;
  newRows: Array<Array<{text: string}>>;
  hadError: boolean;
}

export interface FillStructuredTableUsingAIMatchRowResponse {
  row: Array<{text: string}>;
  index: number;
}

export interface FillStructuredTableUsingAIMatchResultResponse {
  row1: FillStructuredTableUsingAIMatchRowResponse | null;
  row2: FillStructuredTableUsingAIMatchRowResponse | null;
}

export interface FillStructuredTableUsingAIPairwiseComparisonResponse {
  runIndex1: number;
  runIndex2: number;
  matchResults: Array<FillStructuredTableUsingAIMatchResultResponse>;
  isExactMatch: boolean;
}

export interface FillStructuredTableUsingAIResponse {
  runResults: Array<FillStructuredTableUsingAIRunResultResponse>;
  pairwiseComparisons: Array<FillStructuredTableUsingAIPairwiseComparisonResponse>;
}

export interface FillStructuredTableUsingAIFile {
  s3Location: string;
  mediaType: string;
}

export function fillStructuredTableUsingAI(
  entryId: string,
  tableName: string,
  files: Array<FillStructuredTableUsingAIFile>,
  userPrompt: string
): Promise<FillStructuredTableUsingAIResponse> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/notebook/ai-tools:fill-structured-table',
    data: {entryId, tableName, files, userPrompt},
  });
}

export interface SuggestDataEntryClarificationsResponse {
  suggestedFirstRow: Array<{text: string}> | null;
  errorMessage: string | null;
  hadError: boolean;
}

export function suggestDataEntryClarifications(
  entryId: string,
  tableName: string,
  files: Array<FillStructuredTableUsingAIFile>,
  userPrompt: string
): Promise<SuggestDataEntryClarificationsResponse> {
  return Net.postJSONPromise({
    url: '/1/api/notebook/ai-tools:suggest-data-entry-clarifications',
    data: {entryId, tableName, files, userPrompt},
  });
}
